import { Box, Select, Stack, Text } from '@mantine/core';
import { useEffect, useMemo, useState } from 'react';

import { DATA_MAP_OPTIONS } from '../../../../common/enums/enums';
import { NavLink } from 'react-router-dom';
import { toGroupedOptions } from '../../../../../utils/enumUtils';

const IdCell = ({ cell, form, values }) => {
    const { column, renderValue, row } = cell;
    const rowData = row.original;

    const columnFormPath = `columnMap.${column.getIndex()}`;

    //const [mapOptions, setMapOptions] = useState([]);
    const getOptions = () => {
        const values = form.values;
        const existingMaps = Object.values(values?.columnMap || {});
        const currentValue = values?.columnMap?.[column.getIndex()];
        const ret = DATA_MAP_OPTIONS.filter((x) => {
            return !existingMaps.includes(x.value) || x.value == currentValue;
        });
        return toGroupedOptions(ret);
    };

    /*useEffect(() => {
        setMapOptions(getOptions());
    }, [values]);*/

    const mapOptions = useMemo(() => {
        return getOptions();
    }, [values]);

    if (row.index === 0) {
        return (
            <Box>
                <Select
                    data={mapOptions}
                    placeholder={'Column Value'}
                    maxDropdownHeight={500}
                    comboboxProps={{
                        position: 'bottom',
                        middlewares: { flip: false, shift: false },
                    }}
                    {...form.getInputProps(columnFormPath)}
                />
            </Box>
        );
    }

    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}>
            <Text ta={'center'}>{renderValue()}</Text>
        </Box>
    );
};

const IdColumn = (accessorKey, form, values) => ({
    id: accessorKey,
    accessorKey: accessorKey,
    header: 'Id',
    size: 1,
    minSize: 160,
    Cell: ({ cell }) => (
        <IdCell
            cell={cell}
            form={form}
            values={values}
        />
    ),
});
export default IdColumn;
